import React from 'react';

const Loading = () => (
  <div className="spn" />
);
export default Loading;
